<style scoped>
.file-preview {
  margin-left: 10px;
  cursor: pointer;
  text-decoration: underline;
  cursor: pointer;
  color: #4fa1a4;
}
.file-name {
  color: #212121;
  margin-left: 4px;
  margin-right: 4px;
  width: calc(100% - 130px);
}
.file-operate {
  display: flex;
}
/deep/ .el-dialog__body {
  padding-top: 0;
}

/deep/ .el-dialog__body {
  padding-top: 0;
}

/deep/ .el-dialog__header {
  text-align: left;
  padding: 15px 20px 10px;
}

/deep/ .el-dialog__title {
  font-size: 16px;
}

/deep/ .el-upload-list__item-name{
  white-space:inherit;
}

.el-upload__tip {
  line-height: 22px;
}

.el-form-item {
  margin-bottom: 8px;
}
</style>
<template>
  <el-dialog title="填写通过备注" v-loading.fullscreen.lock="fullscreenLoading" :visible.sync="showPass" width="640px"
    class="importClass">
    <div class="pass-box">
      <el-form label-width="120px" label-position="right" class="demo-ruleForm" v-if="showForm">
        <el-form-item v-show="flowType == '00017' && rowData.isApplyStamp == 'Y'">
            <span slot="label" style="color: red">*</span>
            <span slot="label">盖章附件上传：</span>
            <el-upload class="upload-demo fl t-left" action="#" multiple
              accept=".pdf,.PDF,.docx,.xlsx,.doc,.xlsm,.jpg,.png,.jpeg" :on-remove="handleRemoveInvoice"
              :http-request="uploadInvoice" :file-list="paymentAdviceAttach" :beforeUpload="beforeAvatarUpload">
              <el-button size="mini" type="info">点击上传文件</el-button>
              <div class="file-operate" slot="file" slot-scope="{ file }">
                <div class="file-name">{{ file.name }}</div>
                <div class="file-preview" @click="onPreview(file)">查看</div>
                <div class="file-preview" @click="handleRemoveInvoice(file)">删除</div>
                <div class="file-preview" @click="onDownload(file)">下载</div>
              </div>
              <div slot="tip" class="el-upload__tip">
                当前支持 word、pdf、excel、zip、jpg、png，请使用 Office 2010 及以上版本，否则可能出现乱码，单个文件不得大于20M
              </div>
            </el-upload>
        </el-form-item>
        <el-form-item v-show="flowType !== '00017' && rowData.isStamp == 'Y'">
          <span slot="label" style="color: red">*</span>
          <span slot="label">盖章附件上传：</span>
          <el-upload class="upload-demo fl t-left" action="#" multiple
            accept=".pdf,.PDF,.docx,.xlsx,.doc,.xlsm,.jpg,.png,.jpeg" :on-remove="handleRemoveInvoice"
            :http-request="uploadInvoice" :file-list="paymentAdviceAttach" :beforeUpload="beforeAvatarUpload">
            <el-button size="mini" type="info">点击上传文件</el-button>
            <div class="file-operate" slot="file" slot-scope="{ file }">
              <div class="file-name">{{ file.name }}</div>
              <div class="file-preview" @click="onPreview(file)">查看</div>
              <div class="file-preview" @click="handleRemoveInvoice(file)">删除</div>
              <div class="file-preview" @click="onDownload(file)">下载</div>
            </div>
            <div slot="tip" class="el-upload__tip">
              当前支持 word、pdf、excel、zip、jpg、png，请使用 Office 2010 及以上版本，否则可能出现乱码，单个文件不得大于20M
            </div>
          </el-upload>
        </el-form-item>
        <el-form-item v-show="(flowType == '00017' && rowData.isApplyInvoice == 'Y') || flowType !== '00017'">
          <span slot="label" style="color: red">*</span>
          <span slot="label">票据信息上传：</span>
          <el-upload class="upload-demo fl t-left" action="#" multiple 
            accept=".ofd,.pdf,.PDF,.docx,.xlsx,.doc,.xlsm,.zip,.rar,.jpg,.png,.jpeg" :on-remove="handleRemovePayment"
            :http-request="uploadPayment" :file-list="invoiceAttach" :beforeUpload="beforeAvatarUpload">
            <el-button size="mini" type="info">点击上传文件</el-button>
            <div class="file-operate" slot="file" slot-scope="{ file }">
              <div class="file-name">{{ file.name }}</div>
              <div class="file-preview" @click="onPreview(file)">查看</div>
              <div class="file-preview" @click="handleRemovePayment(file)">删除</div>
              <div class="file-preview" @click="onDownload(file)">下载</div>
            </div>
            <div slot="tip" class="el-upload__tip">
              当前支持 word、pdf、excel、zip、jpg、png、ofd，请使用 Office 2010 及以上版本，否则可能出现乱码，单个文件不得大于20M
            </div>
          </el-upload>
        </el-form-item>

        <el-form-item v-show="(flowType == '00017' && rowData.isApplyInvoice == 'Y') || flowType !== '00017'">
          <span slot="label" style="color: red">*</span>
          <span slot="label">开票时间：</span>
          <el-date-picker class="fl w100f" v-model="formData.invoiceDate" type="date" value-format="yyyy-MM-dd"
            placeholder="选择日期">
          </el-date-picker>
        </el-form-item>
        <div style="clear: both"></div>
        <el-form-item v-show="(flowType == '00017' && rowData.isApplyInvoice == 'Y') || flowType !== '00017'">
          <span slot="label" style="color: red">*</span>
          <span slot="label">税率(%)：</span>
          <el-input v-model.trim="formData.taxRate" class="fl" placeholder="请输入"
            onkeyup="value=value.replace(/[^\d.]/g, '')" maxlength="5"></el-input>
        </el-form-item>
        <el-form-item v-if="rowData.isMail == 'Y'">
          <span slot="label" style="color: red">*</span>
          <span slot="label">快递单号：</span>
          <el-input v-model.trim="formData.expressNo" placeholder="限制20个字" maxlength="20"></el-input>
        </el-form-item>
        <el-form-item v-if="rowData.isMail == 'Y'">
          <span slot="label" style="color: red">*</span>
          <span slot="label">快递公司：</span>
          <el-input v-model.trim="formData.expressCompany" placeholder="限制50个字" maxlength="50"></el-input>
        </el-form-item>
      </el-form>

      <el-input class="fl" type="textarea" :rows="5" :maxlength="200" placeholder="最多可输入200个字"
        v-model="formData.approveSuggest">
      </el-input>
      <span slot="footer" class="dialog-footer ">
        <el-button type="info" class="w100f mt15" @click="fileSubmit()">通过</el-button>
      </span>
    </div>
  </el-dialog>
</template>
<script>
import { route } from '@/api/apiRoute';
import store from '@/store';
export default {
  props: {
    flowType: {
      type: String,
      default: '00017',
    },
  },
  // watch: {},
  data() {
    return {
      url: `/${serverConfig.msCommonAdminCloudService}/obs/upload-file`,
      urlImg: `/${serverConfig.msCommonAdminCloudService}/obs/upload-image`,
      token: {
        'Content-Type': 'multipart/form-data',
        Authorization: store.state.token,
      },
      showPass: false,
      showForm: false,
      fullscreenLoading: false,
      rowData: null,
      formData: {
        guid: null,
        invoiceDate: null,
        taxRate: null,
        invoiceAttach: [],//开票附件
        paymentAdviceAttach: [],//付款通知书附件
        expressNo: null,//快递单号
        expressCompany: null,//快递公司
        approveGuid: null,
        approveStaffGuid: null,
        flowType: null,
        approveSuggest: null,
      },
      invoiceAttach: [],
      paymentAdviceAttach: []
    };
  },
  created() { },
  methods: {
    onPreview(file) {
      var fileSuffix = file.name ? file.name.substring(file.name.lastIndexOf('.') + 1) : '';
      if (fileSuffix === 'png' || fileSuffix === 'jpeg' || fileSuffix === 'jpg' || fileSuffix === 'pdf' || fileSuffix === 'zip') {
        return window.open(file.path, file.name);
      }
      if (fileSuffix=='ofd') {
        return window.open("https://ofd.xdocin.com/view?src=" + encodeURIComponent(file.path)); 
      }
      window.open('https://view.officeapps.live.com/op/view.aspx?src=' + file.path);
    },
    onDownload(file) {
      window.open(file.path + '?response-content-type=application/octet-stream');
    },
    open() {
      this.showPass = true;
    },
    fileSubmit() {
      let flg = (this.flowType == '00017' && this.rowData.isApplyInvoice == 'Y');
      if (this.showForm) {
        if (this.flowType == '00017' && this.rowData.isApplyStamp == 'Y' && !this.paymentAdviceAttach.length) {
          this.$message.error('盖章附件上传不能为空！');
          return
        }
        if (this.flowType !== '00017' && this.rowData.isStamp == 'Y' && !this.paymentAdviceAttach.length) {
          this.$message.error('盖章附件上传不能为空！');
          return
        }
        if ((flg || this.flowType !== '00017') && !this.invoiceAttach.length) {
          this.$message.error('票据信息上传不能为空！');
          return
        }
        if ((flg || this.flowType !== '00017') && !this.formData.invoiceDate) {
          this.$message.error('开票日期不能为空！');
          return
        }
        if ((flg || this.flowType !== '00017') && !this.formData.taxRate) {
          this.$message.error('税率不能为空！');
          return
        }
        if (this.rowData.isMail == 'Y' && !this.formData.expressNo) {
          this.$message.error('快递单号不能为空！');
          return
        }
        if (this.rowData.isMail == 'Y' && !this.formData.expressCompany) {
          this.$message.error('快递公司不能为空！');
          return
        }
      }
      this.formData.invoiceAttach = [];
      this.formData.paymentAdviceAttach = [];
      if (this.invoiceAttach && this.invoiceAttach.length > 0) {
        this.invoiceAttach.forEach(i => {
          let obj = {
            fileName: i.name,
            path: i.path
          }
          this.formData.invoiceAttach.push(obj);
        })
      }
      if (this.paymentAdviceAttach && this.paymentAdviceAttach.length > 0) {
        this.paymentAdviceAttach.forEach(i => {
          let payObj = {
            fileName: i.name,
            path: i.path
          }
          this.formData.paymentAdviceAttach.push(payObj);
        })
      }

      let userinfo = JSON.parse(localStorage.userInfo);
      this.formData.guid = this.rowData.guid;
      this.formData.approveGuid = this.rowData.approveGuid || (this.rowData.approveVO && this.rowData.approveVO.approveGuid);
      this.formData.flowType = this.flowType;
      this.formData.approveStaffGuid = userinfo.staffGuid;
      this.formData.taxRate = this.formData.taxRate ? Number(this.formData.taxRate) : null;
      this.fullscreenLoading = true;
      this.api.postJson(`/${serverConfig.msSalesPerformService}/upstream/allow-flow`, this.formData).then((res) => {
        this.fullscreenLoading = false;
        if (res.data.code == serverConfig.REQUIRE_SUCCESS_CODE) {
          this.showPass = false;
          this.formData = {
            guid: null,
            invoiceDate: null,
            taxRate: null,
            invoiceAttach: [],//开票附件
            paymentAdviceAttach: [],//付款通知书附件
            expressNo: null,//快递单号
            expressCompany: null,//快递公司
            approveGuid: null,
            approveStaffGuid: null,
            flowType: null,
            approveSuggest: null,
          },
            this.invoiceAttach = [];
          this.paymentAdviceAttach = [];
          this.$emit('passSuccess', 'success')
          this.$message({
            message: '提交成功',
            type: 'success',
          });
        } else {
          this.$message.error(res.data.msg);
        }
      });
    },
    handleExceedInvoice(files) {
      this.$message.warning(`当前限制选择 1 个文件`);
    },
    handleRemoveInvoice(file) {
      let self = this;
      self.paymentAdviceAttach.forEach(function (j, ind) {
        if (j.path == file.path) {
          self.paymentAdviceAttach.splice(ind, 1);
        }
      });
    },
    //上传限制
    beforeAvatarUpload(file) {
      var testmsg = file.name.substring(file.name.lastIndexOf('.') + 1);
      const isLt2M = file.size / 1024 / 1024 < 20;
      if (!isLt2M) {
        this.$message({
          message: `上传文件大小不能超过 20MB!`,
          type: 'warning',
        });
      }
      return isLt2M;
    },
    uploadInvoice(file) {
      let self = this;
      console.log(file.file);
      let formData = new FormData();
      formData.append('image', file.file);
      self.api
        .postImage(self.urlImg, formData)
        .then((res) => {
          if (res.data.code == serverConfig.REQUIRE_SUCCESS_CODE) {
            let item = {
              name: file.file.name,
              path: res.data.data,
            };
            self.paymentAdviceAttach.push(item);
            self.$message.success('上传成功');
          } else {
            elf.$message.error('上传失败,请重新上传!');
          }
        })
        .catch(() => {
          self.$message('上传失败,请重新上传');
        });
    },
    //付款上传
    handleExceedPayment(files) {
      this.$message.warning(`当前限制选择 1 个文件`);
    },
    handleRemovePayment(file) {
      let self = this;
      self.invoiceAttach.forEach((j, ind) => {
        if (j.path == file.path) {
          self.invoiceAttach.splice(ind, 1);
        }
      });
    },
    uploadPayment(file) {
      let self = this;
      console.log(file.file);
      let formData = new FormData();
      formData.append('image', file.file);
      self.api
        .postImage(self.urlImg, formData)
        .then((res) => {
          if (res.data.code == serverConfig.REQUIRE_SUCCESS_CODE) {
            let item = {
              name: file.file.name,
              path: res.data.data,
            };
            self.invoiceAttach.push(item);
            self.$message.success('上传成功');
          } else {
            elf.$message.error('上传失败,请重新上传!');
          }
        })
        .catch(() => {
          self.$message('上传失败,请重新上传');
        });
    },
    // handlePreview(file){
    //   let fileSuffix = file.name ? file.name.substring(file.name.lastIndexOf('.') + 1) : '';
    //   if (fileSuffix === 'png' || fileSuffix === 'jpeg' || fileSuffix === 'jpg' || fileSuffix === 'pdf') {
    //     return window.open(file.path, file.name);
    //   }
    //   if (fileSuffix.indexOf('.pdf' || '.PDF') > -1) {
    //     return window.open(file.path);
    //   }
    //   if (fileSuffix=='ofd') {
    //     return window.open("https://ofd.xdocin.com/view?src=" + encodeURIComponent(file.path)); 
    //   }
    //   window.open('https://view.officeapps.live.com/op/view.aspx?src=' + file.path);
    // }
  },
};
</script>
